<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-img :src="topics[0].image" class="image"></v-img>
        <div class="after-image">{{ get("company") }} {{ topics[0].text }}</div>
        <h2>
          {{ get("header-1")}}
        </h2>
        <p>
          <linkto :text="company" to="/"></linkto> {{ get("p-1") }}
        </p>
        <p>
          {{ get("p-1.1") }} {{ get("company") }} {{ get("p-1.2") }}
        </p>
        <h2>{{ get("header-2") }}</h2>
        <p>{{ get("p-2") }}</p>
        <h2>{{ get("header-3") }}</h2>
        <p>
          {{ get("p-3.1") }}
          <linkto :text="company" to="/"></linkto> {{ get("p-3.2") }}
          <linkto :text="contact" to="/contact"></linkto> {{ get("p-3.3") }}
          <phonenumber phone="(719) 390-7663"></phonenumber>
        </p>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate></estimate>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import estimate from "@/components/controls/estimate-ctrl";
import router from "@/router";
import linkto from "@/components/controls/link-to";
import localizationMixin from "@/mixins/localization-mixin";
import TopicService from "@/_services/topic-service";
import phonenumber from "@/components/controls/phone-number";

export default {
  name: "roofing-home",

  components: {
    estimate,
    linkto,
    phonenumber,
  },

  created() {
    this.pageName = "roof-home";
    this.topics = TopicService.getTopics();
  },

  data: () => ({
    height: 300,
    width: 675,
    topics: [],
  }),

  mixins: [localizationMixin],
  methods: {
    onAbout() {
      router.push("/about/home");
    },

    getLocalization() {    
      this.topics = TopicService.getTopics();  
    }
  },
};
</script>

<style lang="scss" scoped>
.after-image {
  margin-top: 20px;
  margin-bottom: 20px;
}

.subtitle-span {
  background: rgba(0, 0, 0, 0.5);
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  float: left;
}
</style>
